import { CollisionLevel, type GridPattern } from "~/types/grid.types"

export const FOOT_IN_PIXELS = 120 // 10 pixel = 1 inch
export const INCH_IN_PIXELS = FOOT_IN_PIXELS / 12
export const DEFAULT_GRID_PATTERN = 0
export const DEFAULT_GRID_WIDTH = 8 * FOOT_IN_PIXELS
export const DEFAULT_GRID_HEIGHT = 6 * FOOT_IN_PIXELS
// Hard caps used by the auto-expand-grid feature. Past these, growth is
// refused and the UI shows a "grid is full" toast instead.
export const MAX_GRID_WIDTH_PX = 80 * FOOT_IN_PIXELS   // 80 ft
export const MAX_GRID_HEIGHT_PX = 40 * FOOT_IN_PIXELS  // 40 ft
// todo: improve this implementing offset to the stage/layer or somehow,
// try to not calculate
export const GRID_START_OFFSET = 20
// todo: find a better place for it
export const HEX_HEIGHT_FACTOR = 0.862

export enum SELECTABLE_TOOLS {
  ADD = 'add',
  SELECT = 'select',
  DELETE = 'delete',
  SELECT_ALL = 'select-all',
  LASSO = 'lasso',
  RECT_SELECT = 'rect-select',
  MOVE_GRID = 'move',
  COPY = 'copy',
  CUT = 'cut',
}

export enum GRID_PATTERN_IDS {
  SQUARE = 'square',
  SQUARE_45 = '45-deg',
  HEX = 'hex',
  HEX_90 = 'hex-90',
  FREEFORM = 'freeform',
  HEX_SPACED = 'hex-spaced',
  THREE_D = '3d',
}

export const GRID_PATTERN_LIST: GridPattern[] = [
  {
    id: GRID_PATTERN_IDS.SQUARE,
    label: 'Square Grid',
    image: '/img/pattern/design-pattern-square.webp',
    padding: { x: 60, y: 60 }, //tileSize
    snap: { x: 30, y: 30 },
    fineSnap: { x: 10, y: 10 },
    active: true,
    collisionLevel: CollisionLevel.NEW_OR_COPY,
  },
  {
    id: GRID_PATTERN_IDS.SQUARE_45,
    label: '45 Degree',
    image: '/img/pattern/design-pattern-45deg.webp',
    padding: { x: 60 * Math.sqrt(2), y: 60 * Math.sqrt(2) },
    snap: { x: 15 * Math.sqrt(2), y: 15 * Math.sqrt(2) },
    fineSnap: { x: 10 * Math.sqrt(2), y: 10 * Math.sqrt(2) },
    active: true,
    collisionLevel: CollisionLevel.NONE,
  },
  {
    id: GRID_PATTERN_IDS.HEX,
    label: 'Hex',
    image: '/img/pattern/design-pattern-hex.webp',
    padding: { x: 120, y: 120 * HEX_HEIGHT_FACTOR },
    snap: { x: 30 / 2, y: 30 * HEX_HEIGHT_FACTOR }, // 15 for small ones
    fineSnap: { x: 10 / 2, y: 10 * HEX_HEIGHT_FACTOR },
    active: true,
    collisionLevel: CollisionLevel.NONE,
  },
  {
    id: GRID_PATTERN_IDS.HEX_90,
    label: '90 Degree Hex',
    image: '/img/pattern/design-pattern-90deg-hex.webp',
    padding: { x: 120 * HEX_HEIGHT_FACTOR, y: 120 },
    snap: { x: 30 * HEX_HEIGHT_FACTOR, y: 30 / 2 }, // 15 for small ones
    fineSnap: { x: 10 * HEX_HEIGHT_FACTOR, y: 10 / 2 },
    active: true,
    collisionLevel: CollisionLevel.NONE,
  },
  {
    id: GRID_PATTERN_IDS.FREEFORM,
    label: 'Freeform',
    image: '/img/pattern/design-pattern-freeform.webp',
    padding: { x: 1, y: 1 },
    snap: { x: 1, y: 1 },
    active: true,
    collisionLevel: CollisionLevel.NEW_OR_COPY,
  },
  {
    id: GRID_PATTERN_IDS.HEX_SPACED,
    label: 'Spaced Hex',
    image: '/img/pattern/design-pattern-spaced-hex.webp',
    padding: { x: 120, y: 120 * HEX_HEIGHT_FACTOR }, // others use to generate grid lines, it does not
    snap: { x: 30, y: 30 * HEX_HEIGHT_FACTOR },
    active: true,
    collisionLevel: CollisionLevel.NONE,
  },
  {
    id: GRID_PATTERN_IDS.THREE_D,
    label: '3D',
    image: '/img/pattern/design-pattern-3d.webp',
    padding: { x: 60, y: 60 },
    snap: { x: 30, y: 30 },
    fineSnap: { x: 10, y: 10 },
    active: true,
    collisionLevel: CollisionLevel.NEW_OR_COPY,
  },
]
